if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = true) {
      const $jq = jQuery.noConflict();
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';

      if (preventFocus) this.openedBy = null;
      $jq('.product-slick').slick('unslick')
      $jq('.product-slick-nav').slick('unslick')
      super.hide();
    }
    
    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.removeGalleryListSemantic();
          this.preventVariantURLSwitching();
          super.show(opener);
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;
      const $jq = jQuery.noConflict();
      
      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value);
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    
      $jq('.product-slick').slick({
        slidesToScroll: 1,
        slidesToShow: 1,
        arrows: true,
        nextArrow: $('.prod-icon-next'),
        prevArrow: $('.prod-icon-prev'),
        dots: false,
        asNavFor: '.product-slick-nav',
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              variableWidth: true,
            }
          }
        ]
      });
      
      $jq('.product-slick-nav').slick({
        slidesToShow: 7,
        slidesToScroll: 1,
        asNavFor: '.product-slick',
        dots: false,
        focusOnSelect: true,
        variableWidth: true
      });
    
      // Remove active class and set aria-hidden and tabindex for all thumbnail slides
      $jq('.product-slick-nav .slick-slide').each(function() {
        $jq(this).removeClass('slick-active').attr('aria-hidden', 'true').attr('tabindex', '-1');
      });
    
      // Set active class and remove aria-hidden and tabindex for the first thumbnail slide
      $jq('.product-slick-nav .slick-slide').eq(0).addClass('slick-active').attr('aria-hidden', 'false').attr('tabindex', '0');
    
      // On before slide change match active thumbnail to current slide
      $jq('.product-slick').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        var mySlideNumber = nextSlide;
    
        // Set all slides to aria-hidden true and tabindex -1
        $jq('.product-slick-nav .slick-slide').attr('aria-hidden', 'true').attr('tabindex', '-1').removeClass('slick-active');
        
        // Set the active slide to aria-hidden false and tabindex 0
        $jq('.product-slick-nav .slick-slide').eq(mySlideNumber).addClass('slick-active').attr('aria-hidden', 'false').attr('tabindex', '0');
      });
  }


    preventVariantURLSwitching() {
      this.modalContent.querySelector('variant-radios,variant-selects').setAttribute('data-update-url', 'false');
    }

    removeDOMElements() {
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
      this.productElement.querySelectorAll('variant-selects, variant-radios').forEach((variantSelect) => {
        variantSelect.dataset.originalSection = sectionId;
      });
    }

    removeGalleryListSemantic() {
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;

      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
    }
  });
}
